<div class="pdf-viewer" [class.is-resizing]="isResizing">
  <object [data]="fileId! | httpResourceSrc" type="application/pdf"></object>
  <div class="resize-handle" (mousedown)="startResize($event)"></div>
</div>